function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M24.26 20.34c0 3.42-2.423 6.342-6.845 7.111v3.92h-3.768v-3.648c-2.578-.117-5.076-.811-6.537-1.654l1.154-4.5c1.615.886 3.883 1.693 6.383 1.693 2.191 0 3.691-.848 3.691-2.385 0-1.461-1.23-2.389-4.077-3.348-4.112-1.385-6.921-3.306-6.921-7.033 0-3.386 2.385-6.035 6.499-6.845V0h3.767v3.383c2.576.115 4.309.652 5.576 1.268l-1.115 4.348c-.997-.424-2.767-1.311-5.536-1.311-2.5 0-3.307 1.076-3.307 2.154 0 1.268 1.346 2.074 4.613 3.307 4.579 1.613 6.423 3.728 6.423 7.191z",
  fill: "currentColor"
});

function SvgDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 31.371 31.371"
  }, props), _ref);
}

export default SvgDollar;